import { useState, useEffect } from 'react';
import { systemSettingsApi } from '../api/system-settings.api';

interface FeatureFlags {
  news: boolean;
  competitions: boolean;
  knowledge: boolean;
  snc: boolean;
}

export const useFeatureFlags = () => {
  const [features, setFeatures] = useState<FeatureFlags>({
    news: true,
    competitions: true,
    knowledge: true,
    snc: true,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeatureFlags = async () => {
      try {
        const response = await systemSettingsApi.getAllSettings();
        const settings = response.data.data || [];

        const flags: FeatureFlags = {
          news: true,
          competitions: true,
          knowledge: true,
          snc: true,
        };

        settings.forEach((setting: any) => {
          if (setting.key === 'features.news.enabled') {
            flags.news = setting.value === 'true';
          } else if (setting.key === 'features.competitions.enabled') {
            flags.competitions = setting.value === 'true';
          } else if (setting.key === 'features.knowledge.enabled') {
            flags.knowledge = setting.value === 'true';
          } else if (setting.key === 'features.snc.enabled') {
            flags.snc = setting.value === 'true';
          }
        });

        setFeatures(flags);
      } catch (error) {
        console.error('Failed to fetch feature flags:', error);
        // Keep defaults if fetch fails
      } finally {
        setLoading(false);
      }
    };

    fetchFeatureFlags();
  }, []);

  return { features, loading };
};
